import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { moveFormatter } from "../../fomatters/BooleanFormatter";
import "./ProfileParlay.css";

import Changes from "../../common/Changes";
import SubGroup from "../../common/SubGroup";

const useStyles = makeStyles((theme) => ({
  root: {
    width: 10,
    height: 10,
  },
  button: {
    display: "block",
    marginTop: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));

export default function ProfileParlay(props) {
  const classes = useStyles();

  const userInfo = useMemo(
    () => JSON.parse(localStorage.getItem("userInfo")),
    []
  );

  const onAfterDeleteRow = (ids, rows) =>
    Promise.all(
      ids.map((id, index) =>
        axios.post(
          `${process.env.REACT_APP_API2_URL}/Profile/PlayerProfileParlayLimit_Delete`,
          {
            IdProfile: rows[index].idProfile,
            NumTeams: rows[index].numTeams,
            WagerType: rows[index].idWagerType,
            IdUser: userInfo.userId,
          }
        )
      )
    ).then((response) => {
      getProfileParlayLimit();
    });

  const onAfterInsertRow = (row) => {
    const data = {
      IdProfile: props.Profile.IdProfile,
      NumTeams: row.numTeams,
      Odds: 1,
      MaxRisk: 0,
      MaxPayout: 0,
      ExtraJuice: 0,
      MaxOpenSpots: 0,
      MaxDogLines: 0,
      MaxMoneyLines: 0,
      MaxTotalLines: 0,
      IdUser: userInfo.userId,
    };

    const url = `${process.env.REACT_APP_API2_URL}/Profile/PlayerProfileParlayLimit_Insert`;
    axios.post(url, data).then((response) => {
      getProfileParlayLimit();
    });
  };

  const [selectedLimit, setSelectedLimit] = useState(2);
  const [selectedBasicSport, setSelectedBasicSport] = useState("CBB");
  const [selectedMaxTeamSport, setSelectedMaxTeamSport] = useState("CBB");

  const handleBSRowSelect = (row) => {
    setSelectedBasicSport(row.idSport);
  };
  const handleMTRowSelect = (row) => {
    setSelectedMaxTeamSport(row.idSport);
  };
  const handleLimitRowSelect = (row) => {
    setSelectedLimit(row.numTeams);
  };

  const selectRow = {
    mode: "radio",
    clickToSelect: true,
    selected: [selectedLimit],
    onSelect: handleLimitRowSelect,
  };

  const options = {
    sizePerPage: 1000,
    afterInsertRow: onAfterInsertRow,
    afterDeleteRow: onAfterDeleteRow,
  };

  const selectBSRow = {
    mode: "radio",
    clickToSelect: true,
    selected: [selectedBasicSport],
    onSelect: handleBSRowSelect,
  };

  const selectMTRow = {
    mode: "radio",
    clickToSelect: true,
    selected: [selectedMaxTeamSport],
    onSelect: handleMTRowSelect,
  };

  /**
   * REQUEST DATA
   */
  const [parlayLimit, setParlayLimit] = useState([]);
  const [parlayLimitDetail, setParlayLimitDetail] = useState([]);
  const [parlayBasicSports, setParlayBasicSports] = useState([]);

  const getProfileParlayLimit = useCallback(
    () =>
      axios
        .get(
          `${process.env.REACT_APP_API2_URL}/Profile/PlayerProfileParlayLimit_GetInfo?idProfile=${props.Profile.IdProfile}`
        )
        .then((response) => response.data)
        .then((data) => {
          setParlayLimit(data);
          setSelectedLimit(data[0].numTeams);
        }),
    [props.Profile.IdProfile]
  );
  useEffect(() => {
    getProfileParlayLimit();
  }, [getProfileParlayLimit]);

  const getProfileParlayLimitDetail = useCallback(
    () =>
      axios
        .get(
          `${process.env.REACT_APP_API2_URL}/Profile/PlayerProfileParlayLimitDetail_GetInfo?idProfile=${props.Profile.IdProfile}&numTeams=${selectedLimit}`
        )
        .then((response) => response.data)
        .then((data) => {
          setParlayLimitDetail(data);
        }),
    [props.Profile.IdProfile, selectedLimit]
  );
  useEffect(() => {
    getProfileParlayLimitDetail();
  }, [getProfileParlayLimitDetail]);

  const getProfileParlayBasicSports = useCallback(
    () =>
      axios
        .get(
          `${process.env.REACT_APP_API2_URL}/Profile/PlayerProfileParlayBasicSports_GetInfo?idProfile=${props.Profile.IdProfile}`
        )
        .then((response) => response.data)
        .then((data) => {
          setParlayBasicSports(data);
        }),
    [props.Profile.IdProfile]
  );
  useEffect(() => {
    getProfileParlayBasicSports();
  }, [getProfileParlayBasicSports]);

  useEffect(() => {
    Promise.all([
      getProfileParlayLimit(),
      getProfileParlayLimitDetail(),
      getProfileParlayBasicSports(),
    ]);
  }, []);

  /**
   * LIMIT EDIT
   */
  const onAfterSaveParlayLimit = useCallback(
    (row) => {
      const data = {
        IdProfile: props.Profile.IdProfile,
        NumTeams: row.numTeams,
        IdWagerType: row.idWagerType,
        Odds: row.odds,
        MaxRisk: row.maxRisk,
        MaxPayout: row.maxPayout,
        ExtraJuice: row.extraJuice,
        MaxOpenSpots: row.maxOpenSpots,
        MaxDogLines: row.maxDogLines,
        MaxMoneyLines: row.maxMoneyLines,
        MaxTotalLines: row.maxTotalLines,
        IdUser: userInfo.userId,
      };
      const url = `${process.env.REACT_APP_API2_URL}/Profile/PlayerProfileParlayLimit_Update`;
      axios.post(url, data).then((response) => {
        getProfileParlayLimit();
      });
    },
    [props.Profile.IdProfile]
  );

  const cellEditParlayLimit = {
    mode: "click",
    blurToSave: true,
    afterSaveCell: onAfterSaveParlayLimit,
  };

  /**
   * LIMIT DETAIL EDIT
   */
  const onAfterSaveParlayLimitDetail = useCallback(
    (row) => {
      const data = {
        IdProfile: props.Profile.IdProfile,
        IdSport: row.idSport,
        NumTeams: selectedLimit,
        MaxGames: row.maxGames,
        MaxDogs: row.maxDogs,
        UseFormula: row.useFormula,
        MaxMoneyLines: row.maxMoneyLines,
        MaxTotalLines: row.maxTotalLines,
        IdUser: userInfo.userId,
      };

      const url = `${process.env.REACT_APP_API2_URL}/Profile/PlayerProfileParlayLimitDetail_Update`;
      axios.post(url, data).then((response) => {
        getProfileParlayLimitDetail();
      });
    },
    [props.Profile.IdProfile, selectedLimit]
  );

  const cellEditParlayLimitDetail = {
    mode: "click",
    blurToSave: true,
    afterSaveCell: onAfterSaveParlayLimitDetail,
  };

  /**
   * BASIC SPORTS EDIT
   */
  const onAfterSaveParlayBasicSports = useCallback(
    (row) => {
      const data = {
        IdProfile: props.Profile.IdProfile,
        IdSport: row.idSport,
        BasicSport: row.basicSport,
        IdUser: userInfo.userId,
      };

      const url = `${process.env.REACT_APP_API2_URL}/Profile/PlayerProfileParlayBasicSports_Update`;
      axios.post(url, data).then((response) => {
        getProfileParlayBasicSports();
      });
    },
    [props.Profile.IdProfile]
  );

  const cellEditParlayBasicSports = {
    mode: "click",
    blurToSave: true,
    afterSaveCell: onAfterSaveParlayBasicSports,
  };

  /**
   * Profile Updates
   */
  const [localProfile, setLocalProfile] = useState(props.Profile);
  const handleChange = (event, key, value) => {
    props.Profile[key] = event ? event.target.value : value;
    setLocalProfile({
      ...localProfile,
      [key]: event ? event.target.value : value,
    });
  };

  useEffect(() => {
    setLocalProfile({
      ...props.Profile,
    });
  }, [props.Profile, setLocalProfile]);

  return (
    <div className="grid grid-cols-4 gap-4 h-max">
      <SubGroup title="Odds" className="col-span-4 p-4">
        <BootstrapTable
          data={parlayLimit}
          cellEdit={cellEditParlayLimit}
          options={options}
          selectRow={selectRow}
          insertRow
          deleteRow
          version="4"
          hover
        >
          <TableHeaderColumn
            isKey={true}
            dataField="numTeams"
            editable={() => false}
          >
            Teams
          </TableHeaderColumn>
          <TableHeaderColumn dataField="odds" hiddenOnInsert>
            Odds
          </TableHeaderColumn>
          <TableHeaderColumn dataField="extraJuice" hiddenOnInsert>
            Extra Juice
          </TableHeaderColumn>
          <TableHeaderColumn dataField="maxRisk" hiddenOnInsert>
            Max Risk
          </TableHeaderColumn>
          <TableHeaderColumn dataField="maxPayout" hiddenOnInsert>
            Max Payout
          </TableHeaderColumn>
          <TableHeaderColumn dataField="maxOpenSpots" hiddenOnInsert>
            Open Spots
          </TableHeaderColumn>
          <TableHeaderColumn dataField="maxDogLines" hiddenOnInsert>
            Max Dogs
          </TableHeaderColumn>
          <TableHeaderColumn dataField="maxMoneyLines" hiddenOnInsert>
            Max $-Lines
          </TableHeaderColumn>
          <TableHeaderColumn dataField="maxTotalLines" hiddenOnInsert>
            Max Totals
          </TableHeaderColumn>
        </BootstrapTable>
        <Changes
          title={`Changes`}
          buttonText={"Changes"}
          params={{
            ChangeType: 17,
            IdSport: "",
            Param1: props.Profile.IdProfile,
            Param2: 2,
            Param3: -1,
          }}
        />
      </SubGroup>
      <SubGroup title="Max Teams" className="col-span-3 p-4">
        <BootstrapTable
          data={parlayLimitDetail}
          cellEdit={cellEditParlayLimitDetail}
          selectRow={selectMTRow}
        >
          <TableHeaderColumn dataField="idSport" isKey={true}>
            Sport
          </TableHeaderColumn>
          <TableHeaderColumn dataField="maxGames">Games</TableHeaderColumn>
          <TableHeaderColumn dataField="maxDogs">Dogs</TableHeaderColumn>
          <TableHeaderColumn dataField="maxMoneyLines">
            $-Lines
          </TableHeaderColumn>
          <TableHeaderColumn dataField="maxTotalLines">
            Totals
          </TableHeaderColumn>
        </BootstrapTable>
        <Changes
          title={`Changes`}
          buttonText={"Changes"}
          params={{
            ChangeType: 16,
            IdSport: selectedMaxTeamSport,
            Param1: props.Profile.IdProfile,
            Param2: -1,
            Param3: -1,
          }}
        />
      </SubGroup>
      <SubGroup title="Basic Sports" className="col-span-1 p-4">
        <BootstrapTable
          data={parlayBasicSports}
          cellEdit={cellEditParlayBasicSports}
          selectRow={selectBSRow}
        >
          <TableHeaderColumn dataField="idSport" isKey={true}>
            Sport
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="basicSport"
            dataAlign="center"
            dataFormat={moveFormatter}
            editable={{
              type: "checkbox",
              options: {
                values: "true:false",
              },
            }}
          >
            Basic
          </TableHeaderColumn>
        </BootstrapTable>
        <Changes
          title={`Changes`}
          buttonText={"Changes"}
          params={{
            ChangeType: 20,
            IdSport: selectedBasicSport,
            Param1: props.Profile.IdProfile,
            Param2: 2,
            Param3: -1,
          }}
        />
      </SubGroup>
      <div className="flex-1 vertical-options !gap-0 col-span-4">
        <div className="grid grid-cols-3">
          <div className="flex flex-col items-start col-span-1 gap-2">
            <FormControlLabel
              classes={{ label: classes.label }}
              control={
                <Checkbox
                  size="small"
                  checked={localProfile.pL_TieLoses}
                  onChange={(event) => {
                    handleChange(
                      undefined,
                      "pL_TieLoses",
                      event.target.checked
                    );
                  }}
                  color="primary"
                />
              }
              label="Tie Loses"
            />
            <FormControlLabel
              classes={{ label: classes.label }}
              control={
                <Checkbox
                  size="small"
                  checked={localProfile.pL_AllowOpenPlays}
                  onChange={(event) => {
                    handleChange(
                      undefined,
                      "pL_AllowOpenPlays",
                      event.target.checked
                    );
                  }}
                  color="primary"
                />
              }
              label="Allow Open Plays"
            />
          </div>
          <div className="flex flex-col items-start col-span-1 gap-2">
            <FormControlLabel
              classes={{ label: classes.label }}
              control={
                <Checkbox
                  size="small"
                  checked={localProfile.pL_LowerUseDefault}
                  onChange={(event) => {
                    handleChange(
                      undefined,
                      "pL_LowerUseDefault",
                      event.target.checked
                    );
                  }}
                  color="primary"
                />
              }
              label="Use Table Odds Range"
            />
            <FormControlLabel
              classes={{ label: classes.label }}
              control={
                <Checkbox
                  size="small"
                  checked={localProfile.pL_TrueOddsOption}
                  onChange={(event) => {
                    handleChange(
                      undefined,
                      "pL_TrueOddsOption",
                      event.target.checked
                    );
                  }}
                  color="primary"
                />
              }
              label="If Money Line then Use True Odds"
            />
          </div>
          <div className="flex flex-col items-start col-span-1 gap-2">
            <FormControlLabel
              classes={{ label: classes.label }}
              control={
                <Checkbox
                  size="small"
                  checked={localProfile.pL_AllowSpreadTotalHK}
                  onChange={(event) => {
                    handleChange(
                      undefined,
                      "pL_AllowSpreadTotalHK",
                      event.target.checked
                    );
                  }}
                  color="primary"
                />
              }
              label="Allow Spread and Total in Hockey"
            />
            <FormControlLabel
              classes={{ label: classes.label }}
              control={
                <Checkbox
                  size="small"
                  checked={localProfile.pL_AllowSpreadTotalSOC}
                  onChange={(event) => {
                    handleChange(
                      undefined,
                      "pL_AllowSpreadTotalSOC",
                      event.target.checked
                    );
                  }}
                  color="primary"
                />
              }
              label="Allow Spread and Total in Soccer"
            />
          </div>
        </div>
      </div>
      <div className="grid grid-cols-2 col-span-4 gap-4">
        <div className="flex flex-col gap-4">
          <div className="flex-1 vertical-options !gap-0">
            <h3>Baseball</h3>
            <FormControlLabel
              classes={{ label: classes.label }}
              control={
                <Checkbox
                  size="small"
                  checked={localProfile.pL_AlwaysAction}
                  onChange={(event) => {
                    handleChange(
                      undefined,
                      "pL_AlwaysAction",
                      event.target.checked
                    );
                  }}
                  color="primary"
                />
              }
              label="Always Action"
            />
            <FormControlLabel
              classes={{ label: classes.label }}
              control={
                <Checkbox
                  size="small"
                  checked={localProfile.pL_AllowRunLineTotal}
                  onChange={(event) => {
                    handleChange(
                      undefined,
                      "pL_AllowRunLineTotal",
                      event.target.checked
                    );
                  }}
                  color="primary"
                />
              }
              label="Allow Run Line and Total"
            />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="!gap-0 vertical-options">
              <h3>Parlay Formula</h3>
              <FormControl component="fieldset">
                <RadioGroup
                  label
                  value={localProfile.pL_ParlayFormula ?? 0}
                  onChange={(event) => {
                    handleChange(null, "pL_ParlayFormula", Number(event.target.value));
                  }}
                >
                  <FormControlLabel
                    control={<Radio value={0} size="small" color="primary" />}
                    label="True Odds"
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    control={<Radio value={1} size="small" color="primary" />}
                    label="Ro Mild"
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    control={<Radio value={2} size="small" color="primary" />}
                    label="Ro Total"
                    labelPlacement="end"
                  />
                </RadioGroup>
              </FormControl>
            </div>

            <div className="!gap-0 vertical-options">
              <h3>Check Max Dogs on</h3>
              <FormControlLabel
                classes={{ label: classes.label }}
                control={
                  <Checkbox
                    size="small"
                    checked={localProfile.pL_MaxDogsSide}
                    onChange={(event) => {
                      handleChange(
                        undefined,
                        "pL_MaxDogsSide",
                        event.target.checked
                      );
                    }}
                    color="primary"
                  />
                }
                label="Side"
              />
              <FormControlLabel
                classes={{ label: classes.label }}
                control={
                  <Checkbox
                    size="small"
                    checked={localProfile.pL_MaxDogsTotal}
                    onChange={(event) => {
                      handleChange(
                        undefined,
                        "pL_MaxDogsTotal",
                        event.target.checked
                      );
                    }}
                    color="primary"
                  />
                }
                label="Total"
              />
              <FormControlLabel
                classes={{ label: classes.label }}
                control={
                  <Checkbox
                    size="small"
                    checked={localProfile.pL_MaxDogsMoney}
                    onChange={(event) => {
                      handleChange(
                        undefined,
                        "pL_MaxDogsMoney",
                        event.target.checked
                      );
                    }}
                    color="primary"
                  />
                }
                label="Money Line"
              />
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-4">
          <div className="vertical-options">
            <div className="flex flex-row h-full gap-4">
              <TextField
                size="small"
                type="number"
                label="Max Sides"
                value={localProfile.pL_MaxGames}
                onChange={(event) => handleChange(event, "pL_MaxGames")}
                variant="outlined"
              />
              <TextField
                size="small"
                type="number"
                label="High Level Buy Points"
                value={localProfile.pL_MaxTeamBuyPoints}
                onChange={(event) => handleChange(event, "pL_MaxTeamBuyPoints")}
                variant="outlined"
              />
            </div>
            <div className="flex flex-row h-full gap-4">
              <TextField
                size="small"
                type="number"
                label="Max Buy Points"
                value={localProfile.pL_MaxBuyPoints}
                onChange={(event) => handleChange(event, "pL_MaxBuyPoints")}
                variant="outlined"
              />
              <TextField
                size="small"
                type="number"
                label="Odds Default"
                value={localProfile.pL_OddsDefault}
                onChange={(event) => handleChange(event, "pL_OddsDefault")}
                variant="outlined"
              />
            </div>
            <div className="flex flex-row h-full gap-4">
              <TextField
                size="small"
                type="number"
                label="Max Payout"
                value={localProfile.pL_MaxPayout}
                onChange={(event) => handleChange(event, "pL_MaxPayout")}
                variant="outlined"
              />
              <TextField
                size="small"
                type="number"
                label="Odds Limit"
                value={localProfile.pL_MaxOdds}
                onChange={(event) => handleChange(event, "pL_MaxOdds")}
                variant="outlined"
              />
            </div>
            <div className="flex flex-row items-center !justify-start !gap-2">
              <FormControlLabel
                classes={{ label: classes.label }}
                control={
                  <Checkbox
                    size="small"
                    checked={localProfile.pL_UseMaxSumOdds}
                    onChange={(event) => {
                      handleChange(
                        undefined,
                        "pL_UseMaxSumOdds",
                        event.target.checked
                      );
                    }}
                    color="primary"
                  />
                }
                label="Stop combinations with odds sum higher than"
              />

              <TextField
                className="!w-28"
                size="small"
                type="number"
                value={localProfile.pL_MaxSumOdds}
                onChange={(event) => handleChange(event, "pL_MaxSumOdds")}
                variant="outlined"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
